import styles from "./DashboardCircle.module.scss";
import { Cell, Pie, PieChart } from "recharts";
import React from "react";
import { useTranslation } from "react-i18next";

interface IDashboardCircleProps {
  title: "Gyms" | "Users";
  data: { name: string; value: number; color: string }[];
}

const DashboardCircle: React.FC<IDashboardCircleProps> = ({ data, title }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>{t(title)}</h3>
      <div className={styles.legend}>
        {data.map((entry, index) => (
          <div key={index} className={styles.item}>
            <span style={{ backgroundColor: entry.color }} className={styles.point}></span>
            <span className={styles.text}>
              {t(entry.name)}: {entry.value}
            </span>
          </div>
        ))}
      </div>

      <PieChart width={258} height={258}>
        <Pie
          data={data}
          cx={120}
          cy={120}
          innerRadius={90}
          outerRadius={120}
          fill="#8884d8"
          paddingAngle={5}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>

        <text
          x={120}
          y={110}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={14}
          fill="#333"
        >
          <tspan x={120} dy="-10" fontSize={25}>
            Total
          </tspan>
          <tspan x={120} dy="40" fontSize={35} fontWeight="bold">
            {data.reduce((acc, cur) => acc + cur.value, 0)}
          </tspan>
        </text>
      </PieChart>
    </div>
  );
};

export default DashboardCircle;
